export default "__VITE_ASSET__D8j8yu0v__"